import React from 'react';
import {
  Image,
  Box,
  Text
} from '@chakra-ui/react';

import HeroWithRightMedia from '../../components/sections/herowithrightmedia';


import EVPColumbia from '../../components/ui/ourcompany/leadership/Joe-Boyle.jpeg'
export default function ColumbiaTabPanel() {
  return (
    <Box>
      <HeroWithRightMedia
        title={
          <Box>
            <Text fontWeight={'bold'} mt="10px">
              JOE BOYLE
            </Text>
            <Text fontWeight={'bold'} fontSize="md" mb="8">
              EXECUTIVE VICE PRESIDENT, COLUMBIA BRAND PRESIDENT
            </Text>
            <Text fontSize="xs" mb="4">
              Joe Boyle joined Columbia in 2005 and has served in a variety of
              capacities of increasing leadership and responsibility, including
              brand management, sales, planning, General Merchandising Manager
              of Outerwear, Accessories, Equipment, Collegiate and Licensing,
              Vice President of Apparel Merchandising, and Senior Vice President
              of Columbia Brand Merchandising & Design. He was promoted to
              Executive Vice President, Columbia Brand President in July 2017.
              From 2003 to 2005, Mr. Boyle served in a business development role
              for Robert Trent Jones II Golf Course Architects. Mr. Boyle is a
              fourth-generation member of the company’s founding Boyle family
              and the son of Columbia Chairman, President and CEO Timothy P.
              Boyle.
            </Text>
          </Box>
        }
        media={
          <Image width="500" height="441" borderRadius={10} src={EVPColumbia} />
        }
      />
    </Box>
  );
}
